import { gql } from "@apollo/client";

const TrackFragments = {
  entry: gql`
    fragment Track on Race {
      track {
        id
        trackName: name
        trackCode: code
        perfAbbr
        shortName
        featured
        numberOfRaces
        specialCardTypes: specialCardTypes {
          specialCardTypeAbbreviation
          specialCardTypeName
        }
        trackLocation: location {
          country
        }
        trackDataSource
      }
    }
  `
};

export default TrackFragments;
